import React from "react";
import {useTranslation} from "react-i18next";

const AddressColumn = ({titleKey, addressObject}) => {
  const {t} = useTranslation();

  return (
    <div className="company-address_card">
      <div className="company-address_title">
        <span>{t(titleKey)}</span>
      </div>
      {addressObject ? (
        <>
          {!!addressObject.address && (
            <div className="company-address_line">
              <span>{addressObject.address}</span>
            </div>
          )}
          {!!(addressObject.city || addressObject.zipCode) && (
            <div className="company-address_line">
              <span>
                {[addressObject.zipCode, addressObject.city].filter(Boolean).join(" ")}
              </span>
            </div>
          )}
        </>
      ) : (
        <div className="company-address_line">
          <span>{t("NO_COMPANY_ADDRESS_MESSAGE")}</span>
        </div>
      )}
    </div>
  );
};

const AddressCard = ({mailingAddressObject, visitingAddressObject}) => (
  <div className="company-address_wrapper webkit-msedge-chrome-nicer-scrollbar">
    <AddressColumn
      titleKey="PRESENTATION_MAILING_ADDRESS"
      addressObject={mailingAddressObject}
    />
    <AddressColumn
      titleKey="PRESENTATION_VISITING_ADDRESS"
      addressObject={visitingAddressObject}
    />
  </div>
);

export default AddressCard;
